var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCelloLapingachos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 355.847,
    height: 381.054,
    viewBox: "0 0 355.847 381.054",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_56",
    x: 5.785,
    y: 85.134,
    width: 340.422,
    height: 216.216,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 9,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_57",
    x: 48.111,
    y: 0,
    width: 307.736,
    height: 199.309,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 9,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_58",
    x: 0,
    y: 187.776,
    width: 306.066,
    height: 193.278,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 9,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_68",
    "data-name": "Grupo 68",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, -143.23, -255.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_55",
    "data-name": "Trazado 55",
    d: "M529.93,329.34c-.389,68.122-55.1,122.962-122.209,122.492s-121.178-56.082-120.789-124.2,55.105-122.962,122.209-122.492,121.183,56.082,120.789,124.2",
    transform: "translate(15.106 12.561)",
    fill: "#f3f3e4"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.97, -0.26, 0.26, 0.97, 204.6, 210.19)",
    filter: "url(#Trazado_56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_56-2",
    "data-name": "Trazado 56",
    d: "M550.959,314.455,293.032,312.82a6.28,6.28,0,0,1-6.234-6.312l.519-81.153a6.266,6.266,0,0,1,6.306-6.229l257.928,1.64a6.263,6.263,0,0,1,6.229,6.306l-.508,81.153a6.272,6.272,0,0,1-6.312,6.229",
    transform: "matrix(0.97, 0.26, -0.26, 0.97, -162.85, -182.75)",
    fill: "#bc0b12"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.97, -0.26, 0.26, 0.97, 204.6, 210.19)",
    filter: "url(#Trazado_57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_57-2",
    "data-name": "Trazado 57",
    d: "M410.646,217.724a116.611,116.611,0,0,1,106.362,70.8l11.387.072c.4-5.4,2.076-11.326-.138-15.594-3.114-6.025-13.391-7.626-17.395-13.065-4-5.456-2.474-15.744-7.284-20.515-4.793-4.749-15.059-3.114-20.581-7.09-5.467-3.921-7.173-14.175-13.27-17.24-5.986-3.01-15.241,1.728-21.763-.342-6.362-2.021-11.166-11.249-17.958-12.292-6.82-1.038-14.153,6.339-20.818,6.373-6.847.033-14.258-7.251-20.874-6.168-6.726,1.11-11.42,10.387-17.809,12.513-6.45,2.137-15.76-2.48-21.752.624-6.019,3.12-7.626,13.386-13.071,17.395s-15.738,2.463-20.509,7.289c-4.749,4.788-3.12,15.053-7.091,20.575-3.921,5.456-14.192,7.168-17.246,13.27-1.778,3.523-.867,8.195-.237,12.762l12.784.083a116.6,116.6,0,0,1,107.262-69.452",
    transform: "matrix(0.97, 0.26, -0.26, 0.97, -130.12, -252.47)",
    fill: "#bc0b12"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.97, -0.26, 0.26, 0.97, 204.6, 210.19)",
    filter: "url(#Trazado_58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_58-2",
    "data-name": "Trazado 58",
    d: "M408.626,302.19a116.549,116.549,0,0,1-103.463-64.554l-14.981-.1c-.4,3.413-.558,6.72.823,9.365,3.114,6.025,13.386,7.626,17.4,13.076,4,5.45,2.468,15.738,7.278,20.5,4.793,4.749,15.064,3.12,20.581,7.09,5.461,3.926,7.168,14.192,13.27,17.251,5.986,3,15.236-1.729,21.763.348,6.356,2.015,11.166,11.238,17.963,12.276s14.142-6.328,20.813-6.362c6.853-.027,14.264,7.245,20.879,6.168,6.726-1.115,11.42-10.4,17.8-12.519,6.444-2.137,15.76,2.485,21.752-.618,6.025-3.114,7.632-13.386,13.076-17.389s15.738-2.479,20.5-7.295c4.749-4.793,3.126-15.053,7.085-20.575,3.926-5.461,14.186-7.173,17.246-13.27a12.559,12.559,0,0,0,.95-6.533l-16.478-.1A116.537,116.537,0,0,1,408.626,302.19",
    transform: "matrix(0.97, 0.26, -0.26, 0.97, -170.84, -98.7)",
    fill: "#bc0b12"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_59",
    "data-name": "Trazado 59",
    d: "M392.361,206.576a108.674,108.674,0,0,0-98.531,61.6L490.1,269.423a108.682,108.682,0,0,0-97.736-62.847",
    transform: "translate(31.804 19.051)",
    fill: "#bc0b12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_60",
    "data-name": "Trazado 60",
    d: "M388.857,294.166a108.621,108.621,0,0,0,95.284-55.392l-189.856-1.209a108.6,108.6,0,0,0,94.572,56.6",
    transform: "translate(33.862 159.193)",
    fill: "#bc0b12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_61",
    "data-name": "Trazado 61",
    d: "M308.427,220.7l5.715,34.966-6.533-.044-1.06-6.444-6.737-.044-1.088,6.433-6.588-.044,6.157-34.889Zm-5.274,5.351-2.7,17.146,5.489.039-2.49-17.185Z",
    transform: "translate(24.148 82.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_62",
    "data-name": "Trazado 62",
    d: "M296.814,220.652l6.588.044-.171,27.39a2.958,2.958,0,0,0,.387,1.878,2.034,2.034,0,0,0,1.5.431l1.894.017a2.021,2.021,0,0,0,1.5-.42,2.94,2.94,0,0,0,.408-1.866l.177-27.4,6.538.039-.171,27.147q-.033,4.837-1.811,6.4c-1.187,1.044-3.534,1.552-7.024,1.53l-1.243-.005q-5.243-.033-7-1.618t-1.728-6.422Z",
    transform: "translate(44.547 82.715)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_63",
    "data-name": "Trazado 63",
    d: "M313.512,226.344l-.188,29.345-6.588-.044.188-29.339-6.185-.044.028-5.583,18.968.121-.033,5.583Z",
    transform: "translate(63.047 82.835)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_64",
    "data-name": "Trazado 64",
    d: "M311.463,246.081l-.066,9.481,9.084.061-.028,5.588-15.628-.1.226-34.927,15.622.1-.039,5.588-9.084-.061-.055,8.681,8.233.055-.033,5.588ZM310,224.567l2.479-5.075,6.29.039-4.628,5.064Z",
    transform: "translate(81.525 77.469)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_65",
    "data-name": "Trazado 65",
    d: "M308.679,220.727l6.582.045,5.925,19.294h.044l.127-19.256,6.135.039-.221,34.933-6.836-.049-5.428-18.345h-.044l-.121,18.311-6.384-.038Z",
    transform: "translate(97.954 83.053)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_66",
    "data-name": "Trazado 66",
    d: "M325.35,226.424l-.188,29.339-6.593-.039.193-29.345-6.185-.038.028-5.589,18.969.122-.039,5.588Z",
    transform: "translate(116.583 83.172)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_16",
    "data-name": "Rect\\xE1ngulo 16",
    width: 34.931,
    height: 6.538,
    transform: "translate(451.727 339.002) rotate(-89.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_67",
    "data-name": "Trazado 67",
    d: "M327.7,220.767l1.143.005q5.293.033,7.024,1.612t1.706,6.433l-.039,6.384L331,235.157l.039-6.787a2.168,2.168,0,0,0-.508-1.745,2.889,2.889,0,0,0-1.723-.414l-1.149-.005a2.861,2.861,0,0,0-1.7.387,2.1,2.1,0,0,0-.563,1.745l-.127,20.156c-.005.9.171,1.485.536,1.751a2.9,2.9,0,0,0,1.7.414l1.149.006a2.869,2.869,0,0,0,1.723-.386c.353-.265.53-.845.536-1.745l.05-7.786,6.538.044-.044,7.383q-.033,4.846-1.795,6.4c-1.171,1.049-3.518,1.552-7.046,1.53l-1.143-.006q-5.243-.033-7-1.618t-1.728-6.422l.116-19.361q.033-4.846,1.822-6.406c1.176-1.038,3.523-1.546,7.019-1.524",
    transform: "translate(144.463 83.23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_68",
    "data-name": "Trazado 68",
    d: "M331.821,220.793l1.243.011q5.243.033,7,1.612t1.728,6.422l-.116,19.366c-.022,3.225-.635,5.356-1.817,6.4s-3.529,1.552-7.024,1.53l-1.243-.011q-5.243-.033-7-1.64t-1.728-6.4l.116-19.361q.033-4.846,1.817-6.4c1.182-1.044,3.529-1.552,7.024-1.53m-.094,29.891,1.1.006a2.9,2.9,0,0,0,1.75-.409,2.2,2.2,0,0,0,.558-1.773l.127-20.056a2.188,2.188,0,0,0-.536-1.773,2.854,2.854,0,0,0-1.745-.442l-1.1-.006a2.955,2.955,0,0,0-1.751.392c-.364.265-.552.856-.563,1.789l-.122,20.062c-.005.933.171,1.53.541,1.8a3.006,3.006,0,0,0,1.739.409",
    transform: "translate(163.099 83.347)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69",
    "data-name": "Trazado 69",
    d: "M336.049,220.821l.7.005q5.285.025,7.024,1.613c1.154,1.055,1.728,3.2,1.706,6.428l-.022,3.987-6.538-.039.022-4.44c.005-.9-.166-1.474-.508-1.723a3.035,3.035,0,0,0-1.723-.392l-.7-.005a3.011,3.011,0,0,0-1.723.37c-.353.249-.53.817-.536,1.717l-.022,2.744a3.168,3.168,0,0,0,.607,2.292,9.552,9.552,0,0,0,2.866,1.469l3.286,1.171c.994.37,1.712.657,2.137.861a6.332,6.332,0,0,1,1.5,1.06,3.861,3.861,0,0,1,1.16,1.927,11.5,11.5,0,0,1,.3,2.971l-.033,5.39q-.033,4.837-1.811,6.4t-7.024,1.524l-.9-.005q-5.293-.025-7.024-1.618c-1.154-1.049-1.728-3.192-1.706-6.417l.027-4.092,6.533.039-.022,4.489c-.006.933.166,1.524.508,1.778a3.026,3.026,0,0,0,1.723.387l.9.005a5.748,5.748,0,0,0,1.22-.094,1.18,1.18,0,0,0,.724-.6,2.819,2.819,0,0,0,.309-1.447l.028-4.136a3.788,3.788,0,0,0-.094-.955,3.714,3.714,0,0,0-.193-.624,1.277,1.277,0,0,0-.475-.475c-.249-.171-.431-.287-.541-.353s-.386-.193-.8-.381-.707-.309-.872-.376l-3.534-1.27c-.994-.409-1.723-.723-2.187-.966a8.721,8.721,0,0,1-1.59-1.1,3.865,3.865,0,0,1-1.237-1.955,10.6,10.6,0,0,1-.326-2.949l.017-4.285c.022-3.23.635-5.362,1.822-6.406s3.523-1.546,7.019-1.524",
    transform: "translate(182.219 83.474)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_70",
    "data-name": "Trazado 70",
    d: "M306.461,244.7l.221-34.933,6.538.044-.188,29.339,8.333.05-.033,5.594Z",
    transform: "translate(88.923 33.476)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_71",
    "data-name": "Trazado 71",
    d: "M318.411,209.756l1.242.011q5.244.033,7.008,1.613c1.171,1.06,1.745,3.2,1.723,6.428l-.116,19.366q-.033,4.837-1.811,6.395t-7.03,1.53l-1.242-.006c-3.5-.028-5.826-.569-7-1.646s-1.75-3.2-1.728-6.395l.122-19.366q.025-4.837,1.811-6.4t7.024-1.53m-.089,29.9,1.093.006a2.861,2.861,0,0,0,1.751-.414,2.182,2.182,0,0,0,.558-1.767l.133-20.062a2.2,2.2,0,0,0-.541-1.773,2.85,2.85,0,0,0-1.739-.436l-1.1-.011a2.978,2.978,0,0,0-1.745.392c-.364.265-.558.862-.563,1.795l-.127,20.062c-.005.933.171,1.53.541,1.795a2.924,2.924,0,0,0,1.745.414",
    transform: "translate(102.453 33.441)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_72",
    "data-name": "Trazado 72",
    d: "M322.277,209.781l.7.006c3.529.022,5.865.563,7.024,1.612q1.739,1.6,1.712,6.428l-.028,4-6.538-.044.028-4.445c.006-.889-.166-1.463-.508-1.723a3.085,3.085,0,0,0-1.723-.387h-.7a2.958,2.958,0,0,0-1.717.359c-.359.249-.536.823-.541,1.723l-.016,2.739a3.174,3.174,0,0,0,.607,2.3,9.268,9.268,0,0,0,2.86,1.463l3.291,1.165c.994.376,1.706.663,2.137.873a6.316,6.316,0,0,1,1.491,1.055,3.886,3.886,0,0,1,1.16,1.927,11.516,11.516,0,0,1,.309,2.971l-.033,5.4c-.022,3.219-.63,5.362-1.811,6.4s-3.534,1.552-7.024,1.524l-.9-.011q-5.293-.025-7.024-1.618-1.74-1.574-1.706-6.422l.028-4.086,6.533.044-.028,4.484c-.005.933.166,1.524.514,1.784a3.038,3.038,0,0,0,1.723.376l.895.011a5.773,5.773,0,0,0,1.226-.094,1.149,1.149,0,0,0,.718-.6,2.772,2.772,0,0,0,.315-1.447l.028-4.142a4.011,4.011,0,0,0-.1-.95,3.543,3.543,0,0,0-.193-.624,1.288,1.288,0,0,0-.469-.475c-.248-.166-.431-.287-.541-.353s-.386-.188-.8-.376-.707-.315-.873-.375l-3.54-1.281c-.988-.4-1.723-.718-2.181-.961a8.12,8.12,0,0,1-1.59-1.1,3.806,3.806,0,0,1-1.237-1.955,10.56,10.56,0,0,1-.331-2.949l.022-4.291c.022-3.219.629-5.362,1.822-6.4s3.523-1.552,7.019-1.53",
    transform: "translate(119.94 33.55)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_73",
    "data-name": "Trazado 73",
    d: "M289.917,262.882l.221-34.933,6.538.044-.188,29.345,8.338.05-.039,5.594Z",
    transform: "translate(14.109 115.711)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_74",
    "data-name": "Trazado 74",
    d: "M309.348,228.042l5.721,34.966-6.533-.039-1.066-6.444-6.731-.044-1.093,6.433-6.582-.044,6.157-34.894Zm-5.268,5.351-2.706,17.152,5.489.033-2.485-17.185Z",
    transform: "translate(28.336 115.835)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_75",
    "data-name": "Trazado 75",
    d: "M297.707,262.931,297.928,228l9.724.061q5.1.033,6.781,1.563T316.1,235.7l-.055,8.438q-.033,4.639-1.712,6.1t-6.82,1.43l-3.2-.022-.072,11.331ZM307.52,233.5l-3.092-.017L304.35,246.2l3.092.022a2.777,2.777,0,0,0,1.5-.315c.331-.221.5-.707.508-1.474l.055-9.084a1.739,1.739,0,0,0-.491-1.5,2.6,2.6,0,0,0-1.5-.359",
    transform: "translate(49.337 115.934)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_17",
    "data-name": "Rect\\xE1ngulo 17",
    width: 34.931,
    height: 6.538,
    transform: "translate(369.45 379.01) rotate(-89.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76",
    "data-name": "Trazado 76",
    d: "M304.091,228.037l6.582.045,5.925,19.294.044.006.127-19.262,6.135.033-.221,34.938-6.836-.044-5.428-18.35h-.044l-.121,18.311-6.384-.038Z",
    transform: "translate(77.207 116.113)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_77",
    "data-name": "Trazado 77",
    d: "M317.12,228.038l1.093.006q5.243.033,7.008,1.618c1.176,1.06,1.745,3.2,1.728,6.428l-.028,3.893-6.538-.044.033-4.3a2.112,2.112,0,0,0-.541-1.745,2.886,2.886,0,0,0-1.7-.414l-1.1-.006a2.9,2.9,0,0,0-1.7.387,2.109,2.109,0,0,0-.563,1.745l-.127,20.31c-.006.9.166,1.458.513,1.679a3.393,3.393,0,0,0,1.717.337l1.1.006a7.275,7.275,0,0,0,1.226-.066,1.225,1.225,0,0,0,.7-.519,2.454,2.454,0,0,0,.331-1.4l.039-6.29-3.043-.017.033-5.439,9.586.055-.072,11.182q-.033,4.837-1.811,6.4c-1.187,1.044-3.534,1.552-7.024,1.53l-1.1-.011q-5.243-.025-7-1.618-1.756-1.574-1.729-6.417l.116-19.366c.022-3.225.635-5.362,1.822-6.406s3.523-1.541,7.019-1.524",
    transform: "translate(96.619 116.115)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_78",
    "data-name": "Trazado 78",
    d: "M328.442,228.158l5.721,34.972-6.533-.044-1.06-6.444-6.737-.039-1.093,6.428-6.582-.044,6.157-34.889Zm-5.268,5.357-2.706,17.146,5.495.039-2.491-17.185Z",
    transform: "translate(114.681 116.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_79",
    "data-name": "Trazado 79",
    d: "M325.661,228.094l1.143.005q5.3.033,7.024,1.618,1.74,1.582,1.712,6.422l-.044,6.389-6.533-.044L329,235.7a2.191,2.191,0,0,0-.508-1.751,2.934,2.934,0,0,0-1.723-.409l-1.149-.011a2.859,2.859,0,0,0-1.7.392c-.37.265-.558.845-.563,1.745l-.127,20.161a2.119,2.119,0,0,0,.536,1.751,2.921,2.921,0,0,0,1.7.409l1.143.011a2.854,2.854,0,0,0,1.723-.392c.353-.265.53-.845.536-1.745l.055-7.781,6.533.039-.044,7.389q-.033,4.837-1.795,6.4c-1.171,1.044-3.512,1.546-7.041,1.524l-1.149-.005q-5.243-.025-7-1.618t-1.728-6.422l.121-19.361c.016-3.231.63-5.362,1.817-6.406s3.523-1.546,7.019-1.524",
    transform: "translate(135.238 116.363)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_80",
    "data-name": "Trazado 80",
    d: "M320.969,263.079l.221-34.933,6.538.044-.094,14.269,5.539.033.094-14.269,6.582.044-.221,34.928-6.583-.039.088-14.722L327.6,248.4l-.088,14.722Z",
    transform: "translate(154.529 116.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_81",
    "data-name": "Trazado 81",
    d: "M334.191,228.148l1.242.005q5.243.033,7,1.618t1.728,6.422l-.121,19.366c-.017,3.225-.63,5.356-1.811,6.4s-3.529,1.546-7.024,1.53l-1.242-.011q-5.243-.033-7-1.64t-1.728-6.4l.116-19.366q.033-4.837,1.817-6.4t7.024-1.524m-.094,29.891,1.093.005a2.912,2.912,0,0,0,1.756-.409,2.2,2.2,0,0,0,.558-1.773l.127-20.062a2.184,2.184,0,0,0-.536-1.773,2.856,2.856,0,0,0-1.745-.436l-1.1-.006a2.989,2.989,0,0,0-1.751.386c-.364.265-.558.862-.563,1.789l-.121,20.067c-.006.933.171,1.53.541,1.8a2.963,2.963,0,0,0,1.74.409",
    transform: "translate(173.817 116.608)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_82",
    "data-name": "Trazado 82",
    d: "M338.42,228.175h.7q5.285.033,7.024,1.618c1.154,1.06,1.728,3.2,1.706,6.428l-.028,3.992-6.533-.044.022-4.44c.006-.9-.166-1.475-.508-1.723a3.037,3.037,0,0,0-1.723-.392l-.7-.005a3,3,0,0,0-1.723.37c-.353.243-.53.817-.536,1.717l-.022,2.745a3.174,3.174,0,0,0,.613,2.3,9.476,9.476,0,0,0,2.86,1.469l3.286,1.165q1.491.563,2.137.861a6.67,6.67,0,0,1,1.5,1.06,3.861,3.861,0,0,1,1.16,1.927,11.581,11.581,0,0,1,.3,2.976l-.033,5.39q-.033,4.837-1.811,6.395t-7.024,1.53l-.9-.005q-5.293-.033-7.024-1.618t-1.706-6.422l.027-4.092,6.533.039-.022,4.5c-.005.933.16,1.524.508,1.773a3.027,3.027,0,0,0,1.723.387l.9.006a5.1,5.1,0,0,0,1.22-.094,1.152,1.152,0,0,0,.724-.591,2.832,2.832,0,0,0,.309-1.447l.028-4.142a3.765,3.765,0,0,0-.094-.95,3.079,3.079,0,0,0-.2-.624,1.212,1.212,0,0,0-.469-.475c-.249-.171-.425-.287-.541-.353s-.386-.193-.8-.381-.707-.315-.867-.375l-3.54-1.276c-.988-.4-1.723-.723-2.187-.961a8.552,8.552,0,0,1-1.59-1.1,3.912,3.912,0,0,1-1.237-1.955,10.622,10.622,0,0,1-.331-2.954l.027-4.285c.017-3.23.63-5.362,1.817-6.406s3.523-1.546,7.019-1.524",
    transform: "translate(192.941 116.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83",
    "data-name": "Trazado 83",
    d: "M323.62,239.286l3.484,10.928,11.464.077-9.321,6.693,3.485,10.945-9.25-6.8-9.327,6.687,3.622-10.906-9.249-6.809,11.48.072Z",
    transform: "translate(98.269 166.98)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelloLapingachos);
export default __webpack_public_path__ + "static/media/cello_lapingachos.c583ccd5504fab70c7867d685d4bbaea.svg";
export { ForwardRef as ReactComponent };